export default class clientesService{

	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/clientes',
            "list_all": '/api/clientes/list/all',
			"id": '/api/clientes/:id',
			"new": '/api/clientes',
			"delete": "/api/clientes/:id",
            'update': '/api/clientes'
		};
	}

    getAll(filters){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filters
		};
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

    getAllList(filters){
        let url = this.baseUrl + this.routes.list_all;
        let config = {
            params : filters
        };
        return this.http.get(url, config);
    }

    update(data){
        let url = this.baseUrl + this.routes.new;
        return this.http.put(url, data);
    }

    delete(objId){
        let idRoute = this.routes.delete.replace(':id', objId._id);
        let url = this.baseUrl + idRoute;
        return this.http.delete(url);
    }
}



// WEBPACK FOOTER //
// ./app/js/services/clientesService.js